import React, { useEffect, useState } from "react";
import "./SalesByCustomerAnalytics.scss";

import PiChart from "../Charts/PiChart/PiChart";
import { useSelector } from "react-redux";

const SalesByCustomerAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);

  const { customerAnalytics: customerAnalystsData, salesAnalytics } =
    useSelector((state) => state.analyticsReducer);

  const [totalData, setTotalData] = useState({
    revenue: 0,
    sales: 0,
  });

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    let temp_revenue = 0;
    let temp_sales = 0;

    customerAnalystsData?.revenue_by_customer?.forEach((el, index) => {
      temp_revenue += el?.total_revenue || 0;
      temp_sales += el?.total_sales || 0;

      if (labels.length < 5) {
        labels.push(el?.name || "N/A");
        dataSet.push(el?.total_revenue);
      } else {
        if (labels.length === 5) {
          labels[4] = "Others";
          dataSet[4] = (dataSet[4] || 0) + el?.total_revenue || 0;
        } else {
          dataSet[4] += el?.total_revenue || 0;
        }
      }
    });

    setTotalData({
      revenue: Number(temp_revenue).toFixed(2),
      sales: temp_sales,
    });

    setData({
      labels: labels,
      datasets: [
        {
          data: dataSet,
          backgroundColor: [
            "#092B3A",
            "#65C1E8",
            "#C1E6F6",
            "#DCF2FB",
            "#115774",
          ],
          borderWidth: 0,
        },
      ],
    });
  }, [customerAnalystsData]);
  return (
    <div className="sales-by-customer">
      <div className="container-wrapper sales-customer">
        <div className="revenue-box">
          <div className="left content">
            <p className="title">Avg. Revenue</p>
            <span>
              <span
                className={
                  salesAnalytics?.percentage_change_revenue > 0
                    ? `success`
                    : "danger"
                }
              >
                {salesAnalytics?.percentage_change_sale}%
              </span>{" "}
              From {salesAnalytics?.previous_filter_type}
            </span>
            <p className="amount">
              {currency}{salesAnalytics?.average_revenue || 0.0}
            </p>
          </div>
          <div className="right content">
            <p className="title">Avg. Sales</p>
            <span>
              <span
                className={
                  salesAnalytics?.percentage_change_sale > 0
                    ? `success`
                    : "danger"
                }
              >
                {salesAnalytics?.percentage_change_sale}%
              </span>{" "}
              From {salesAnalytics?.previous_filter_type}
            </span>
            <p className="amount">
              {salesAnalytics?.average_sales || 0}
            </p>
          </div>
        </div>
        <p className="heading">Spend by Customer Chart</p>

        <div className="sales-staff-chart">
          {data?.labels?.length < 1 && (
            <p className="no-data">No data present for this period.</p>
          )}
          <div className="chart-container">
            <PiChart data={data} currency={currency} />
          </div>
          <div className="chart-contents">
            {data?.labels?.map((el, i) => {
              return (
                <div className="item" key={i}>
                  <div
                    className="circle"
                    style={{
                      backgroundColor: `${data.datasets[0].backgroundColor[i]}`,
                    }}
                  ></div>
                  <p>
                    <span>
                      {(
                        Number(data.datasets[0].data[i] / totalData.revenue) *
                        100
                      ).toFixed(2)}
                      %
                    </span>{" "}
                    spend by {el}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <p className="heading">Sales Record</p>
        <div className="revenue-table">
          <div className="row head">
            <p>Customer</p>
            <p>QTY</p>
            <p>Amount</p>
            <p>%</p>
          </div>

          <div className="table-body">
            {customerAnalystsData?.revenue_by_customer?.map((el, i) => {
              return (
                <div className="row" key={i}>
                  <p>{el?.name || "N/A"}</p>
                  <p>{el?.total_sales || 0}</p>
                  <p>
                    {currency}
                    {Number(el?.total_revenue).toFixed(2) || "0.00"}
                  </p>
                  <p>
                    {Number(
                      (el?.total_revenue / totalData.revenue) * 100
                    ).toFixed(2) || 0}
                    %
                  </p>
                </div>
              );
            })}

            <div className="row total">
              <p>Total</p>
              <p>{totalData?.sales || 0}</p>
              <p>
                {currency}
                {totalData?.revenue || "0.00"}
              </p>
              <p>{totalData?.revenue ? "100%" : "0.00%"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesByCustomerAnalytics;
